import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { OneWayInService } from 'src/api/v2';
import { ONE_WAY_IN_CUSTOMER_COMMUNICATION_GET_THREADS } from 'src/constants/hook-keys';
import { useAuth } from 'src/features/authorization';

const useCustomerEmails = (opportunityId: string) => {
  const [service] = useState(() => new OneWayInService());
  const { checkAccess } = useAuth();
  const { read } = checkAccess('OneWayIn');

  const { data, ...rest } = useQuery({
    queryKey: [ONE_WAY_IN_CUSTOMER_COMMUNICATION_GET_THREADS, opportunityId],
    queryFn: () => service.getAllEmailThreadsForOpportunity(opportunityId),
    enabled: read,
    retry: false,
    staleTime: 1000 * 60 * 5, // 5 min refetching on mount
    refetchOnMount: true,
  });

  return {
    threads: data,
    ...rest,
  };
};

export default useCustomerEmails;
